import React, { useEffect } from 'react'
import TextField from '@mui/material/TextField'
import Autocomplete from '@mui/material/Autocomplete'
import MenuItem from '@mui/material/MenuItem'

// Icons
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import ExpandLessIcon from '@mui/icons-material/ExpandLess'

// Components
import GradientCircularProgressIndicator from './GradientCircularProgressIndicator'

// MUI Components
import { FormControl, Typography } from '@mui/material'

const DropdownIcon = (props) => {
    return props.open ? <ExpandLessIcon {...props} sx={{ color: '#D1D5DB' }} /> : <ExpandMoreIcon {...props} sx={{ color: '#D1D5DB' }} />
}

export default function AsyncAutocompleteDropDown({
    title,
    label,
    value,
    onChange,
    // size='small',
    options=[],
    valueKey = 'value',
    labelKey = 'label',
    placeholder = '',
    disabled = false,
    fullWidth = true,
    sx={},
    loading = false,
    ...props
}) {
    const [open, setOpen] = React.useState(false)
    const [asyncOptions, setAsyncOptions] = React.useState([])
    const [loadingState, setLoadingState] = React.useState(false)

    const handleOpen = () => {
        setOpen(true)
        setLoadingState(loading)
        if (!loadingState) {
            setAsyncOptions(options)
        }
    }

    useEffect(() => {
        setLoadingState(loading)
        if (!loadingState) {
            setAsyncOptions(options)
        }
    }, [loadingState, options])

    const handleClose = () => {
        setOpen(false)
    }

    return (
        <FormControl fullWidth={fullWidth} sx={sx}>
            {title ? (
                title
            ) : label ? (
                <Typography 
                    sx={{ 
                        fontSize: '14px',
                        fontWeight: 500,
                        color: '#374151',
                        mb: 1
                    }}
                >
                    {label}
                </Typography>
            ) : null}
            <Autocomplete
                value={value}
                // size={size}
                fullWidth={fullWidth}
                sx={{
                    ...sx,
                    '& .MuiOutlinedInput-root': {
                        backgroundColor: '#FFFFFF',
                        borderRadius: '6px',
                        fontSize: '14px',
                        boxShadow: '0 1px 2px 0 rgb(0, 0, 0, 0.05)',
                        '& fieldset': {
                            borderColor: '#E5E7EB',
                        },
                        '&:hover fieldset': {
                            borderColor: '#D1D5DB',
                        },
                        '&.Mui-focused fieldset': {
                            borderColor: '#1F477D',
                            borderWidth: '2px',
                        },
                    },
                    '& .MuiOutlinedInput-input': {
                        padding: '12px 14px',
                        fontSize: '14px',
                        color: value ? '#111827' : '#9CA3AF',
                    },
                    '& .MuiAutocomplete-popupIndicator': {
                        color: '#6B7280',
                        '& svg': {
                            fontSize: '20px',
                        },
                    },
                    '& .MuiAutocomplete-clearIndicator': {
                        display: 'none',
                    },
                }}
                open={open}
                onOpen={handleOpen}
                onClose={handleClose}
                onChange={onChange}
                isOptionEqualToValue={(option, value) => {
                    if (!value) return false
                    return option[valueKey] === value[valueKey]
                }}
                getOptionLabel={(option) => option[labelKey]}
                options={options}
                loading={loadingState}
                popupIcon={<DropdownIcon />}
                slotProps={{
                    paper: {
                        sx: {
                            borderRadius: '6px',
                            border: '1px solid #E5E7EB',
                            boxShadow: '0 1px 2px 0 rgb(0, 0, 0, 0.05)',
                            maxHeight: '200px',
                            minHeight: '40px',
                            marginTop: '4px',
                        },
                    },
                }}
                renderInput={(params) => (
                    <TextField
                    {...params}
                    fullWidth
                    placeholder={value ? '' : loading && open ? 'Loading...' : placeholder}
                    slotProps={{
                        input: {
                        ...params.InputProps,
                        endAdornment: (
                            <React.Fragment>
                            {open && loading ? <GradientCircularProgressIndicator size={20} /> : null}
                            {params.InputProps.endAdornment}
                            </React.Fragment>
                        ),
                        },
                    }}
                    size="small"
                    sx={{
                        minHeight: '40px',
                        '& .MuiOutlinedInput-root': {
                            backgroundColor: '#FFFFFF',
                            borderRadius: '6px',
                            fontSize: '14px',
                            boxShadow: '0 1px 2px 0 rgb(0, 0, 0, 0.05)',
                            '& fieldset': {
                                borderColor: '#E5E7EB',
                            },
                            '&:hover fieldset': {
                                borderColor: '#D1D5DB',
                            },
                            '&.Mui-focused fieldset': {
                                borderColor: '#1F477D',
                                borderWidth: '2px',
                            },
                        },
                        '& .MuiOutlinedInput-input': {
                            padding: '12px 14px',
                            fontSize: '14px',
                            color: '#111827',
                            '&::placeholder': {
                                color: '#9CA3AF',
                                opacity: 1,
                            },
                        },
                    }}
                    />
                )}
                renderOption={(props, option) => (
                    <MenuItem 
                        {...props} 
                        value={option[valueKey]}
                        sx={{
                            fontSize: '14px',
                            color: '#111827',
                            '&:hover': {
                                backgroundColor: '#F9FAFB',
                            },
                            '&.Mui-selected': {
                                backgroundColor: '#EEF2FF',
                                '&:hover': {
                                    backgroundColor: '#E0E7FF',
                                },
                            },
                        }}
                    >
                        <Typography sx={{ color: '#111827', fontStyle: 'normal', fontSize: '14px' }}>
                            {option[labelKey]}
                        </Typography>
                    </MenuItem>
                )}
            />
        </FormControl>
    );
}
